import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["icon", "children"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { STATUS_TYPES } from '../../constants';
import { statusIconAppearance } from '../../util/statusIconAppearance';
import { StyledInlineFeedback } from './InlineFeedback.styles';

/**
 * `InlineFeedback` is a subtle status message that is embedded within the content of the page.
 * For a more prominent message, consider using the `Alert` component.
 *
 * @since 7.17.0
 */
export var InlineFeedback = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var icon = props.icon,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var iconContent = icon;
  if (typeof icon === 'function') {
    iconContent = icon(props);
  }
  return /*#__PURE__*/React.createElement(StyledInlineFeedback, _extends({
    ref: forwardedRef
  }, rest), iconContent, children);
});
InlineFeedback.displayName = 'InlineFeedback';
InlineFeedback.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The type and style of inline feedback to display.
   */
  appearance: PropTypes.oneOf([].concat(_toConsumableArray(Object.keys(STATUS_TYPES)), ['transient'])),
  /**
   * The icon node. By default, this will use an icon based on the inline feedback `appearance`.
   */
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * The text content of the inline feedback message.
   */
  children: PropTypes.node.isRequired
} : {};
InlineFeedback.defaultProps = {
  appearance: 'info',
  icon: statusIconAppearance
};